import Vue from 'vue'
import VueRouter from 'vue-router'

import announcement from './announcement'
import personCenter from './personCenter'
import jobUnitQuery from './jobUnitQuery'
import projectProgress from './projectProgress'
import project from './projectAppoint'
import TabbarHome from '../views/TabbarHome.vue'
import information from './information'
import opinionPublish from './opinionPublish'
import consultComplaiont from './consultComplaiont'
import projectPublicity from './projectPublicity'
import satisfactionRate from './satisfactionRate'


Vue.use(VueRouter)

const routes = [
  ...projectProgress,
  ...jobUnitQuery,
  ...project,
  ...announcement,
  ...information,
  ...opinionPublish,
  ...consultComplaiont,
  ...projectPublicity,
  ...satisfactionRate,
  personCenter,
  {
    path: '/',
    name: 'TabbarHome',
    component: TabbarHome,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('../views/Home.vue')
      },
      {
        path: 'personal',
        name: 'Personal',
        component: () => import('../views/PersonalCenter/index.vue')
      }
    ]
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/PersonalCenter/register.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/PersonalCenter/login.vue')
  },
  {
    path: '/loginSuccess',
    name: 'LoginSuccess',
    component: () => import('../views/PersonalCenter/login.vue')
  },
  {
    path: '/loginFail',
    name: 'LoginFail',
    component: () => import('../views/PersonalCenter/login.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
